import styled from 'styled-components';
import Summary from './components/summary/Summary';
import { CaseInfo, NearDataProps, RealSalesFilter } from './data';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import DetailService, { INplInfo } from '../../service/detail';
import {
  AroundRealDealFilter,
  BasicInfoProps,
  HouseInfoProps,
  LandInfoProprs,
  RealDealFilter,
  Renter,
} from './data';
import { NplCalculation } from '../../utils/nplAnalysis';
import { useNavigate, useParams } from 'react-router-dom';
import { useReportContext } from '../../context/DetailContext';
import SideInfo from '../../sidebar';
import BasicInfo from './components/basicInfo/BasicInfo';
import ItemState from './components/ItemState/ItemState';
import SaleInfo from './components/saleInfo/SaleInfo';
import TenantStatus from './components/TenantStatus/TenantStatus';
import AuctionAppraisalPrice from './components/appraisalPrice/AppraisalPrice';
import { RegisterStatus } from './components/registerStatus/RegisterStatus';
import CheckList from './components/checkList/CheckList';
import ExpectedDividendTable from './components/expectedDividend/ExpectedDividendTable';
import AuctionCosts from './components/auctionCosts/AuctionCosts';
import AptComplexInfo from './components/AptComplexInfo';
import PriceAnalysis from './components/priceAnalysis/PriceAnalysis';
import SaleStatistics from './components/saleStatistics/SaleStatistics';
import JurisdictionCourt from './components/jurisdictionCourt/JurisdictionCourt';
import AiRecommendation from './components/aiRecommendation/AiRecommendation';
import Menu from '../components/menu/Menu';
import ScrollToTopButton from '../components/ScrollToTopButton';
import NPLSummary from './components/nplAnalysis/nplSummary';
import OverView from './components/nplAnalysis/OverView';
import RealEstateStatus from './components/nplAnalysis/RealEstateStatus';
import SaleDateSimulation from './components/nplAnalysis/SaleDateSimulation';
import SeniorityDetails from './components/nplAnalysis/SeniorityDetails';
import ExpectedLoanPrincipal from './components/nplAnalysis/ExpectedLoanPrincipal';
import ExpectedInvestmentPeriod from './components/nplAnalysis/ExpectedInvestmentPeriod';
import ExpectedDividendAnalysis from './components/nplAnalysis/ExpectedDividendAnalysis';
import CostAnalysis from './components/nplAnalysis/CostAnalysis';
import ProfitAnalysis from './components/nplAnalysis/ProfitAnalysis';
import Loading from '../../func/components/loading/LoadingCircle';
import NPLNavigationTab from './components/nplAnalysis/nplAnalysisNavigationTab';
import NavigationTab from './components/NavigationTab';
import { userGradeType } from '../../utils/auth';
import { useModal } from '../../context/ModalContext';
import { ACommonList } from '../../sidebar';
import AttachmentFile from './AttachmentFile';
import AttachmentFileModal from './AttachmentFileModal';
import DetailOrNplTab from './components/nplAnalysis/DetailOrNplTab';
import LoanInfoService from '../../service/LoanInfo';
import NearList from './components/aiRecommendation/NearList';
import DetailPageTop from '../components/pageTop/DetailPageTop';
import NPLInvestmentSummary from './components/summary/NPLInvestmentSummary';
import InterestSerivce from '../../service/Interest';
import Inquire from './components/Inquire';
import DetailPageFooter from '../components/footer/DetailPageFooter';
import QuotaService from '../../service/quota/Quota';
import NearRealPrice from './components/priceAnalysis/NearRealPrice';
import NearRealSale from './components/priceAnalysis/NearRealSale';
import SameRealPrice from './components/priceAnalysis/SameRealPrice';
import SameRealSale from './components/priceAnalysis/SameRealSale';
import OutLinkSection from './components/OutLinkSection';
import RelativeTab from './components/RelativeTab';

interface DataProps {
  type: string;
  img: string;
  saledate: string;
  caseno: string;
  unitno: string;
  address: string;
  viewgray: string;
  appraisedprice: string;
  minprice: string;
  bid: string;
  bidprice: string;
  a_per: number;
  viewgray2: string;
  b_area: string;
  l_area: string;
  iidx: string;
  court: string;
  category: string;
  is_like: boolean;
  courtname?: string;
}
interface fileProps {
  link: string;
  title: string;
}

const AuctionDetail = () => {
  const { modalDispatch, modal } = useModal();
  const {
    type,
    setType,
    itemType,
    setItemType,
    setLat,
    setLng,
    setBid,
    setGeom,
    setZoning,
    iidx,
    setIidx,
    regionAccess,
    setRegionAccess,
    quotaAccess,
    setQuotaAccess,
  } = useReportContext();
  const navigate = useNavigate();
  const { number } = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const listType = searchParams.get('type');

  const [tab, setTab] = useState('auction');
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [nplQuotaAccess, setNplQuotaAccess] = useState(false);

  const [caseInfo, setCaseInfo] = useState<CaseInfo | null>(null);
  const [caseno, setCaseno] = useState('');
  const [imgList, setImgList] = useState([]);
  const [basicInfo, setBasicInfoData] = useState<BasicInfoProps>();
  const [landInfo, setLandInfo] = useState<LandInfoProprs>();
  const [houseInfo, setHouseInfo] = useState<HouseInfoProps>();
  const [saleInfo, setSaleInfoData] = useState();
  const [totalSaleList, setTotalSaleList] = useState();
  const [landSaleList, setLandSaleList] = useState();
  const [buildingSaleList, setBuildingSaleList] = useState();
  const [renterInfo, setRenterInfo] = useState<Renter[]>([]);
  const [rentNote, setRentNote] = useState([]);
  const [note2, setNote2] = useState('');
  const [writeDate, setWriteDate] = useState('');
  const [landRegisterStatus, setLandRegisterStatus] = useState();
  const [buildingRegisterStatus, setBuildingRegisterStatus] = useState();
  const [registerNote, setRegisterNote] = useState();
  const [expectedValueList, setExpectedValueList] = useState<any>([]);
  const [expectedValueList2, setExpectedValueList2] = useState<any>([]);
  const [expectedValueList2Info, setExpectedValueList2Info] = useState<any>();
  const [locationInfo, setLocationInfo] = useState('');
  const [appraisalevaluation, setAppraisalEvaluation] = useState('');
  const [realPriceData, setRealPriceData] = useState(); // 동일물건 실거래가
  const [realDealFilter, setRealDealFilter] = useState<RealDealFilter>({
    iidx: Number(iidx) ?? 0,
    b_idx: 0,
    distance: 500,
    limit: 6,
    offset: 0,
  });

  const [courtInfo, setCourtInfo] = useState();
  const [linkSet, setLinkSet] = useState();

  const [expectedDividend, setExpectedDividend]: any = useState(); // 예상배당표
  const [checkList, setCheckList] = useState();
  const [auctionCostsData, setAuctionCostsData] = useState();
  const [relatedItem, setRelatedItem] = useState();
  const [nplAnalysis, setNplAnalysis] = useState<NplCalculation>();
  const [nplInfo, setNplInfo] = useState<INplInfo>();
  const [saleItemInfo, setSaleItemInfo] = useState([]); //이용현황
  const [subHouseInfo, setSubHouseInfo] = useState(); //총괄표제부
  const [anotherRegisterStatus, setAnotherRegisterStatus] = useState();
  const [sameAddressItems, setSameAddressItems] = useState<DataProps[]>([]);
  const [sameAddressItems2, setSameAddressItems2] = useState<DataProps[]>([]);
  const [appraisalInfo, setAppraisalInfo] = useState();
  const [note, setNote] = useState();
  const [attachmentFile, setAttachmentFile] = useState<fileProps[]>([]);
  const [showFileModal, setShowFileModal] = useState(false);
  const [groupCategory, setGroupCategory] = useState(''); //그룹카테고리 //A7일 때만 업빌드 나옴
  const [aTable, setATable] = useState(''); //감정평가 요항표
  const [sameItemAddr, setSameItemAddr] = useState('');
  const [naverLink, setNaverLink] = useState();
  const [viewInfo, setViewInfo] = useState(null);
  const [isLikeItem, setIsLikeItem] = useState(false); // 관심 여부
  const [auctionDetail, setAuctionDetail] = useState();
  const [relativeList, setRelativeList] = useState([]); // 관련 물건

  const { npl } = location.state || {};
  const [isTopButton, setIsTopButton] = useState(false);
  const [countIdx, setCountIdx] = useState('');

  useEffect(() => {
    if (!modal.userAlert.open) {
      if (modal.userAlert.type !== null && modal.userAlert.type === 'guest') {
        if (window.history.length > 1) {
          navigate(-1);
        } else {
          window.close();
        }
      }
    }
  }, [modal.userAlert.open]);

  const countView = async (iidx: string) => {
    try {
      const res = await LoanInfoService.viewCount(iidx);
      setCountIdx(res.data);
    } catch (e) {
      console.log(e);
    }
  };

  const callViewCountValid = async (countIdx: string) => {
    try {
      await LoanInfoService.viewCountValid(countIdx);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (!countIdx) return;

    const intervalId = setInterval(() => {
      callViewCountValid(countIdx);
    }, 60 * 1000);

    return () => clearInterval(intervalId);
  }, [countIdx]);

  const checkIsLikeItem = async (iidx: number) => {
    try {
      const res = await InterestSerivce.check(iidx);
      setIsLikeItem(res.data.is_like);
    } catch (error) {
      console.error('checkIsLikeItem 함수에서 에러 발생:', error);
    }
  };

  useEffect(() => {
    if (caseInfo && caseInfo.iidx) {
      checkIsLikeItem(caseInfo.iidx);
    }
  }, [caseInfo, isLikeItem]);

  useEffect(() => {
    if (number) {
      setIidx(number);
    }
    setRealDealFilter({
      ...realDealFilter,
      iidx: Number(number) ?? 0,
    });
  }, [number]);

  const getOneNameWithSubHouseInfo = (arr: any[]): string | null => {
    const found = arr.find((item) => item.mainminorcodename === '주건축물');
    return found ? found.buildingname : '';
  };

  const itemDetailButtonOn = !!caseInfo?.iidx;
  const casDetailButtonOn = !!caseInfo?.iidx;
  const dateDetailButtonOn = !!caseInfo?.iidx;
  const itemDetailLink = `/itemDetailPage?iidx=${caseInfo?.iidx}`;
  const commonList = ACommonList(
    caseInfo,
    itemDetailButtonOn,
    casDetailButtonOn,
    dateDetailButtonOn,
  );

  const getDetailData = async (iidx: number) => {
    setLoading(true);
    try {
      const res = await DetailService.detail(iidx);
      if (res.status === 'success') {
        const info = res.data.info;
        const caseInfoData = info.caseInfo || {};
        const basicInfoData = info.loanInfo ? info.loanInfo[0] : null;
        const has_detail = !!basicInfoData;
        setRegionAccess(res.data.regionAccess ?? true);
        setGroupCategory(res.data.info.group_category);
        setRelativeList(res.data.listOfUnitno);
        sessionStorage.setItem('groupCategory', res.data.info.group_category);
        setType(res.data.info.caseInfo.type);
        setCaseInfo(res.data.info.caseInfo);
        setImgList(res.data.info.imgs);
        if (res.data.houseInfo) {
          setItemType(res.data.houseInfo.length > 0 ? 'H' : 'L');
          setHouseInfo(
            res.data.houseInfo.length > 0
              ? res.data.houseInfo[0]
              : { approvaldate: 'nodata' },
          );
          setSameItemAddr(
            res.data.houseInfo.length > 0
              ? res.data.subHouseInfo.length > 0
                ? (getOneNameWithSubHouseInfo(res.data.subHouseInfo) ?? '')
                : ''
              : res.data.info.caseInfo.iaddr,
          );
        }
        if (res.data.landInfo) {
          setLandInfo(
            res.data.landInfo.length > 0
              ? res.data.landInfo[0]
              : { address: 'nodata' },
          );
          setZoning(res.data.landInfo[0].zoning_backup ?? '');
        }
        if (res.data.mapInfo && res.data.mapInfo.length > 0) {
          setLat(res.data.mapInfo[0].lat);
          setLng(res.data.mapInfo[0].lng);
          const wkt = res.data.mapInfo[0].geom;
          const coordinates = wkt
            .replace('MULTIPOLYGON(((', '') // WKT 헤더 제거
            .replace(')))', '') // 마지막 괄호 제거
            .split(',') // 좌표 문자열 분리
            .map((coord: any) => {
              const [lng, lat] = coord.trim().split(' ').map(Number);
              return [lng, lat]; // 배열 형식으로 변환
            });
          setGeom(coordinates);
        }
        setBasicInfoData(res.data.info.loanInfo[0]);
        setCaseno(res.data.info.caseInfo.caseno);
        setBid(res.data.info.caseInfo.bid);
        setSaleInfoData(res.data.info.info);
        setAttachmentFile(res.data.info.file);
        setTotalSaleList(res.data.itemLists.totalSaleList);
        setLandSaleList(res.data.itemLists.landSaleList);
        setBuildingSaleList(res.data.itemLists.constructionSaleList);
        setRenterInfo(res.data.itemStatus.itemStatus.rentInfo);
        setRentNote(res.data.itemStatus.itemStatus.note);
        setNote2(res.data.itemStatus.itemStatus.note2);
        setWriteDate(res.data.itemStatus.itemStatus.write_date);
        setNote(res.data.itemStatus.itemStatus.note);
        setSaleItemInfo(res.data.itemStatus.itemStatus.saleItemInfo);
        setLandRegisterStatus(res.data.registerationDoc.regDoc.landRegInfo);
        setBuildingRegisterStatus(
          res.data.registerationDoc.regDoc.constructRegInfo,
        );
        setRegisterNote(res.data.registerationDoc.regDoc.note);
        setExpectedValueList(res.data.expectedValueList);
        setExpectedValueList2(res.data.expectedValueList2);
        setExpectedValueList2Info(res.data.expectedValueList2Info);
        setCourtInfo(res.data.courtInfo[0]);
        setAppraisalInfo(res.data.itemLists.info[0]);
        setCheckList(res.data.rightsCheckList);
        setAuctionCostsData(res.data.auctExecCost);
        setRelatedItem(res.data.listOfUnitno);
        setSubHouseInfo(res.data.subHouseInfo);
        setAnotherRegisterStatus(res.data.registerationDoc.regDoc.another);
        setExpectedDividend(res.data.expectedDividend);
        setLinkSet(res.data.link);
        if (res.data.naverLink) {
          setNaverLink(res.data.naverLink);
        }
        setViewInfo(res.data.viewInfo);

        setATable(res.data.info.a_table);
        const auctionDetail = await DetailService.auctionDetail(iidx);
        if (auctionDetail.data.isPossible) {
          setAuctionDetail(auctionDetail.data);
        }
      }
    } catch (error: any) {
      // 다른 오류 처리
      console.error('API 오류:', error);
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  const getRealDealPriceList = async (data: RealDealFilter) => {
    try {
      const { iidx, b_idx, distance, limit, offset, is_same1, is_same2 } = data;
      const res = await DetailService.realDealPrice(
        iidx,
        b_idx,
        distance,
        limit,
        offset,
        is_same1,
        is_same2,
      );
      setRealPriceData(res.data);
    } catch (e) {
      console.log(e);
    }
  };
  //동일 물건 실거래가 조회
  useEffect(() => {
    if (iidx !== '') {
      getRealDealPriceList({ ...realDealFilter, iidx: Number(iidx) });
    }
  }, [iidx, realDealFilter]);

  async function getNplData(iidx: number) {
    try {
      setLoading(true);

      const nplInfo = await DetailService.getNplAnalysis(iidx);

      setNplAnalysis(
        new NplCalculation(
          Number(nplInfo.appraisedprice),
          Number(nplInfo.claimAmount),
          nplInfo.stats,
          nplInfo.ai,
          nplInfo.sale_date.map((el) => ({ ...el, price: Number(el.price) })),
          nplInfo.bondPrice,
          nplInfo.court,
          nplInfo.seniorInfo,
          nplInfo.is_company,
          nplInfo.marketPrc,
        ),
      );
      setNplInfo(nplInfo);
    } catch (e) {
      console.error('getNplData', e);
      setIsError(true);
    } finally {
      setLoading(false);
    }
  }

  const GetList = async (iidx: number) => {
    try {
      const res = await DetailService.nearbyItems(iidx);
      setSameAddressItems(res.data.list1);
      setSameAddressItems2(res.data.list2);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > 50) {
        setIsTopButton(true);
      } else {
        setIsTopButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const summaryRef = useRef<HTMLDivElement>(null);
  const [isScrolledPastSummary, setIsScrolledPastSummary] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!summaryRef.current) return;
      const rect = summaryRef.current.getBoundingClientRect();
      setIsScrolledPastSummary(rect.bottom <= 56); // 헤더 높이 기준
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 서비스 이용권 사용
  const serviceQuota = async (type: string, iidx: number) => {
    try {
      const data = {
        type,
        iidx,
      };
      await QuotaService.use(data);
    } catch (err) {
      console.log(err, '발생');
    }
  };

  // 서비스 이용권 확인
  const getServiceQuotaCheck = async (type: string, iidx: number) => {
    try {
      const res = await QuotaService.check(type, iidx);

      return res.data;
    } catch (err) {
      console.log(err, '발생');
      return false;
    }
  };

  const DetailQuotaCheck = async () => {
    const res = await getServiceQuotaCheck('A', Number(iidx));
    setQuotaAccess(res);
  };

  const NPLQuotaCheck = async () => {
    const res = await getServiceQuotaCheck('C', Number(iidx));
    setNplQuotaAccess(res);
  };

  useEffect(() => {
    if (iidx !== '') {
      getDetailData(Number(iidx)); // 상세 정보
      GetList(Number(iidx)); // 동일 지번 물건
      countView(iidx); // 유효 조회수
      DetailQuotaCheck(); // 이용권 확인
      serviceQuota('A', Number(iidx)); // 이용권 사용
    }
  }, [iidx]);

  useEffect(() => {
    if (tab === 'npl' && iidx !== '' && !nplInfo) {
      serviceQuota('C', Number(iidx)); // 이용권 사용
      getNplData(Number(iidx));
    }
  }, [tab, iidx, nplInfo]);

  useEffect(() => {
    if (iidx && listType === 'b') {
      NPLQuotaCheck();
    }
  }, [iidx, listType]);

  return (
    <Container>
      <DetailPageTop
        caseInfo={caseInfo}
        isScrolledPastSummary={isScrolledPastSummary}
        isLikeItem={isLikeItem}
        setIsLikeItem={setIsLikeItem}
        checkIsLikeItem={checkIsLikeItem}
      />
      <DetailOrNplTab
        tab={tab}
        setTab={setTab}
        nplQuotaAccess={nplQuotaAccess}
      />
      {tab === 'auction' &&
        !isError &&
        (loading ? (
          <Loading />
        ) : (
          <Inner>
            {/* 요약정보 */}
            {caseInfo && (
              <Summary
                caseInfo={caseInfo}
                imgList={imgList}
                basicInfo={basicInfo}
                realPriceData={realPriceData}
                landInfo={landInfo}
                viewInfo={viewInfo}
                ref={summaryRef}
                isLikeItem={isLikeItem}
                setIsLikeItem={setIsLikeItem}
                checkIsLikeItem={checkIsLikeItem}
                relativeList={relativeList}
                isNPL={listType === 'b'}
              />
            )}
            <Inquire />
            <div>
              <NavigationTab />

              {/* 물건기본정보 */}
              {basicInfo && (
                <BasicInfo
                  data={basicInfo}
                  caseInfo={caseInfo}
                  linkSet={linkSet}
                  assetDetailLink={itemDetailLink}
                />
              )}
            </div>

            {/* 기일현황 */}
            {saleInfo && <SaleInfo data={saleInfo} linkSet={linkSet} />}

            {/* 물건현황 */}
            {landInfo && houseInfo && (
              <ItemState
                subHouseInfo={subHouseInfo}
                landInfo={landInfo}
                houseInfo={houseInfo}
                appraisalevaluation={appraisalevaluation}
                locationInfo={locationInfo}
                groupCategory={groupCategory}
                caseInfo={caseInfo}
                linkSet={linkSet}
                naverLink={naverLink}
              />
            )}

            {/* 유용한 사이트 */}
            {linkSet && (
              <OutLinkSection linkSet={linkSet} auctionDetail={auctionDetail} />
            )}

            {/* 임차인현황 */}
            {renterInfo && rentNote && appraisalInfo && (
              <TenantStatus
                renterInfo={renterInfo}
                rentNote={rentNote}
                note2={note2}
                writeDate={writeDate}
                appraisalInfo={appraisalInfo}
              />
            )}

            {/* 등기부 현황 */}
            {landRegisterStatus &&
              buildingRegisterStatus &&
              anotherRegisterStatus &&
              registerNote && (
                <RegisterStatus
                  landInfo={landRegisterStatus}
                  buildingInfo={buildingRegisterStatus}
                  registerNote={registerNote}
                  anotherInfo={anotherRegisterStatus}
                  linkSet={linkSet}
                />
              )}

            {/* 감정가 */}
            {totalSaleList &&
              landSaleList &&
              buildingSaleList &&
              appraisalInfo &&
              saleItemInfo && (
                <AuctionAppraisalPrice
                  totalSaleList={totalSaleList}
                  landSaleList={landSaleList}
                  buildingSaleList={buildingSaleList}
                  appraisalInfo={appraisalInfo}
                  saleItemInfo={saleItemInfo}
                  a_table={aTable}
                  data={appraisalInfo}
                  linkSet={linkSet}
                />
              )}

            {/* 권리분석 체크 리스트 - 경매 */}
            {checkList && <CheckList data={checkList} />}
            {/* 예상 배당표  - 경매 */}
            {expectedDividend && caseInfo && (
              <ExpectedDividendTable
                expectedDividend={expectedDividend}
                iidx={Number(iidx)}
                caseInfo={caseInfo}
              />
            )}
            {/* 경매집행비용  - 경매 */}
            {auctionCostsData && <AuctionCosts data={auctionCostsData} />}

            {/* 단지정보 */}
            <AptComplexInfo
              type="A"
              idx={Number(iidx)}
              setLinkSet={setLinkSet}
            />

            {/* 가격분석 */}
            <PriceAnalysis />

            {/* 동일 물건 */}
            {/* 실거래가 */}
            <SameRealPrice
              sameItemAddr={sameItemAddr}
              realPriceData={realPriceData}
              realDealFilter={realDealFilter}
              setRealDealFilter={setRealDealFilter}
            />
            {/* 매물가격 */}
            <SameRealSale sameItemAddr={sameItemAddr} />
            {/* 진행 물건 */}
            {sameAddressItems.length > 0 && (
              <AiRecommendation
                title="동일 지번 진행 물건"
                data={sameAddressItems}
                status="진행"
              />
            )}
            {/* 낙찰 물건 */}
            {sameAddressItems2.length > 0 && (
              <AiRecommendation
                title="동일 지번 낙찰 물건"
                data={sameAddressItems2}
                status="낙찰"
              />
            )}

            {/* 인근 물건 */}
            {/* 실거래가 */}
            <NearRealPrice />
            {/* 매물가격 */}
            <NearRealSale />
            {/* 진행 물건 */}
            <NearList
              iidx={iidx ?? ''}
              title="인근 반경 진행 물건"
              status="B"
              regionAccess={regionAccess}
            />
            {/* 낙찰 물건 */}
            <NearList
              iidx={iidx ?? ''}
              title="인근 반경 낙찰 물건"
              status="A"
              regionAccess={regionAccess}
            />

            {/*매각통계*/}
            <SaleStatistics
              expectedValueList={expectedValueList}
              expectedValueList2={expectedValueList2}
              expectedValueList2Info={expectedValueList2Info}
            />

            {/*관할법원 */}
            {courtInfo && (
              <JurisdictionCourt
                courtInfo={courtInfo}
                linkSet={linkSet}
                caseInfo={caseInfo}
              />
            )}
            {/* 첨부파일 */}
            {linkSet && (
              <AttachmentFile
                linkSet={linkSet}
                caseInfo={caseInfo}
                setShowFileModal={setShowFileModal}
              />
            )}
            {showFileModal && (
              <AttachmentFileModal
                showFileModal={showFileModal}
                setShowFileModal={setShowFileModal}
                attachmentFile={attachmentFile}
                linkSet={linkSet}
              />
            )}
          </Inner>
        ))}
      {tab === 'npl' &&
        !isError &&
        (loading ? (
          <Loading />
        ) : (
          <ReportContainer id="printable">
            <Inner>
              {caseInfo && nplAnalysis && (
                <NPLInvestmentSummary
                  caseInfo={caseInfo}
                  basicInfo={basicInfo}
                  summary={nplAnalysis.getSummary()}
                  realPriceData={realPriceData}
                  landInfo={landInfo}
                  viewInfo={viewInfo}
                  ref={summaryRef}
                  isLikeItem={isLikeItem}
                  setIsLikeItem={setIsLikeItem}
                  checkIsLikeItem={checkIsLikeItem}
                />
              )}
              <Inquire />
              <div>
                <NPLNavigationTab />
                {caseInfo && nplAnalysis && nplInfo && (
                  <ReportDetail>
                    {/* NPL 분석요약 */}
                    <div id="분석요약">
                      <NPLSummary
                        caseInfo={caseInfo}
                        summary={nplAnalysis.getSummary()}
                        info={nplInfo}
                      />
                    </div>

                    {/* 채권 내 물건별 개요 */}
                    <div id="물건개요">
                      <OverView itemList={nplInfo.itemList} />
                    </div>

                    {/* 부동산 현황 */}
                    <div id="부동산현황">
                      <RealEstateStatus info={nplInfo} />
                    </div>

                    {/* 매각기일 시뮬레이션 */}
                    <div id="매각기일">
                      <SaleDateSimulation
                        saleInfo={saleInfo}
                        bidDateSimulation={nplAnalysis.getBidDateSimul()}
                      />
                    </div>

                    {/* 선순위 내역 */}
                    <div id="선순위내역">
                      <SeniorityDetails
                        seniorityDetails={nplAnalysis.getSeniorInfo()}
                      />
                    </div>

                    {/* 예상 투자기간 */}
                    <div id="투자기간">
                      <ExpectedInvestmentPeriod
                        expectedInvestmentPeriod={nplAnalysis.getExpectedInvestmentDays()}
                      />
                    </div>

                    {/* 예상 대출원리금 */}
                    <div id="대출원리금">
                      <ExpectedLoanPrincipal
                        expectedLoanPrincipal={nplAnalysis.getExpectedLoan()}
                      />
                    </div>

                    {/* 예상 배당분석 */}
                    <div id="배당분석">
                      <ExpectedDividendAnalysis
                        expectedDividendAnalysis={nplAnalysis.getExpectedDividendAnalysis()}
                      />
                    </div>

                    {/* 비용 분석 */}
                    <div id="비용분석">
                      <CostAnalysis
                        profitAnalysis={nplAnalysis.getProfitAnalysis()}
                      />
                    </div>

                    {/* 수익 분석 */}
                    <div id="수익분석">
                      <ProfitAnalysis
                        revenueAnalysis={nplAnalysis.getRevenueAnalysis()}
                      />
                    </div>
                  </ReportDetail>
                )}
              </div>
            </Inner>
          </ReportContainer>
        ))}

      <ScrollToTopButton />
      <DetailPageFooter />
    </Container>
  );
};

export default AuctionDetail;

const Container = styled.div`
  width: 100%;

  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
  overflow-x: clip;
`;

const Inner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: #f0f0f0;
`;

const TabBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);
`;
const TabButton = styled.span<{ active: boolean }>`
  flex: 1;
  padding: 10px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 500;
  color: ${(props) => (props.active ? '#222' : '#989BA2')};
  border-bottom: ${(props) => (props.active ? '2px solid #222' : 'none')};
  cursor: pointer;
`;

const CaseNumberBox = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 700;
  color: white;
  background-color: #000;
`;
const CourtName = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.64);
`;

const ReportContainer = styled.div`
  width: 100%;
  background-color: #fff;
  font-family: Spoqa Han Sans Neo;
  position: relative;
  display: flex;
  flex-direction: column;
`;
const ReportDetail = styled.div`
  width: 100%;
  gap: 8px;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
`;
